import './App.css';
import Layout from "./components/Layout";
import Home from "./Home";

function App() {
  return (
    <Layout>
      <Home />
    </Layout>
  );
}

export default App;
